import DetalhesNotasFiscaisViewModel from "@/shared/view-models/DetalhesNotasFiscaisViewModel";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue"

export default defineComponent({
  name: 'PDFNotaFiscal',

  props: {
    notaFiscal: {
      type: String,
      default: ''
    },
  },

  beforeMount() {
    var today = new Date();
    var year = today.getDate()+" de "+(this.monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  mounted() {
    this.GetDetalhesNotasFiscais();

    var today = new Date();
    var year = today.getDate()+" de "+(this.monthNames[today.getMonth()]+" de "+ today.getFullYear());
    this.DiaHoje = year;
  },

  data() {
    return {
      infosNotaFiscal: new DetalhesNotasFiscaisViewModel(),
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      DiaHoje: null,
      DataEmissao: '',
      mesDataEmissao: ''
    }
  },

  methods: {
    GetDetalhesNotasFiscais() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesNotasFiscais/${this.notaFiscal}`,
      })
      .then((response) => {
        Tools.objectCustomAssign(this.infosNotaFiscal, Tools.captalizeKeys(response.data.data))
        this.executaTermino()
        
        var dataDesfragmentada = this.infosNotaFiscal.DataEmissaoFormatada.split("/")
        var pegaMesDataDesfragmentada = dataDesfragmentada[1].split("")

        if(pegaMesDataDesfragmentada[0] == '0') {
          this.mesDataEmissao = pegaMesDataDesfragmentada[1]
        } else {
          this.mesDataEmissao = dataDesfragmentada[1]
        }

        this.DataEmissao = `${dataDesfragmentada[0]} de ${this.monthNames[parseInt(this.mesDataEmissao)]} de ${dataDesfragmentada[2]}` 
      })
      .finally(()=> {
        this.$isLoading(false)
      })
    },

    executaTermino() {                
      this.$emit('termino')              
    },
  }
})